import {GbdokulinkService} from "../../../core/gb-api";
import {log} from "../../../log/log";
import {FormatTimepointPipe} from "../../pipes/format/format-timepoint.pipe";
import {FormatRechteIdPipe} from "../../pipes/format/format-rechte-id.pipe";
import {KompaktGrundstueckPipe} from "../../kompaktdarstellung/grundstueck/kompakt-grundstueck.pipe";
import {FormatBelegPipe} from "../../pipes/format/format-beleg.pipe";
import {AppPermissionService} from "../../../core/services/app-permission.service";
import {
  AlteGrundbuchmeldungDokuLinkItemBuilder,
  BelegAltDokuLinkItemBuilder,
  BelegDokuLinkItemBuilder,
  BelegOhneGeschaeftDokuLinkItemBuilder,
  DokulinkItemBuilder,
  GrundbuchGeschaeftDokuLinkItemBuilder,
  GrundstueckDokuLinkItemBuilder,
  RechtDokuLinkItemBuilder,
  TimepointDokuLinkItemBuilder
} from "./dokulinkItemBuilder";
import {Injectable} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";


export type DokulinkItemSubtype =
  'BELEG'
  | 'GBGESCHAEFT'
  | 'GRUNDSTUECK'
  | 'RECHT'
  | 'GESCHAEFT'
  | 'BELEG_ALT'
  | 'BELEG_OHNE_GESCHAEFT'
  | 'ALTE_GRUNDBUCHMELDUNG';

@Injectable()
export class DokulinkItemBuilderFactory {

  constructor(private translateService: TranslateService, private formatTimepoint: FormatTimepointPipe, private formatRecht: FormatRechteIdPipe,
              private formatGrundstueck: KompaktGrundstueckPipe, private formatBeleg: FormatBelegPipe, private dokulinkService: GbdokulinkService, private permissionService: AppPermissionService) {
  }

  create(subtype: DokulinkItemSubtype): DokulinkItemBuilder<any> {
    switch (subtype) {
      case 'GESCHAEFT':
        return new TimepointDokuLinkItemBuilder(this.formatTimepoint, this.dokulinkService, this.permissionService).setSubtype(subtype);
      case 'GBGESCHAEFT':
        return new GrundbuchGeschaeftDokuLinkItemBuilder(this.formatTimepoint, this.dokulinkService, this.permissionService).setSubtype(subtype);
      case 'BELEG_ALT':
        return new BelegAltDokuLinkItemBuilder(this.formatBeleg, this.dokulinkService, this.permissionService).setSubtype(subtype);
      case 'BELEG_OHNE_GESCHAEFT':
        return new BelegOhneGeschaeftDokuLinkItemBuilder(this.formatBeleg, this.dokulinkService, this.permissionService).setSubtype(subtype);
      case 'RECHT':
        return new RechtDokuLinkItemBuilder(this.translateService, this.formatRecht, this.dokulinkService, this.permissionService).setSubtype(subtype);
      case 'GRUNDSTUECK':
        return new GrundstueckDokuLinkItemBuilder(this.formatGrundstueck, this.dokulinkService, this.permissionService).setSubtype(subtype);
      case 'BELEG':
        return new BelegDokuLinkItemBuilder(this.formatBeleg, this.dokulinkService, this.permissionService)
          .setSubtype(subtype);
      case 'ALTE_GRUNDBUCHMELDUNG':
        return new AlteGrundbuchmeldungDokuLinkItemBuilder(this.formatTimepoint, this.dokulinkService).setSubtype(subtype);
      default:
        log.error(new Error('DokulinkType: ' + subtype + ' not available'));
    }
  }
}
